export function pillChipActiveSx(surface) {
  if (surface === 'secondary') {
    return {
      color: 'var(--app-btn-pill-text)',
      bgcolor: 'var(--app-btn-pill-bg)',
      border: '1px solid transparent',
      borderColor: 'transparent',
      boxShadow: 'none',
      '&:hover': {
        bgcolor: 'var(--app-btn-pill-hover)',
        borderColor: 'transparent',
        boxShadow: 'none',
      },
      '&:active': { boxShadow: 'none' },
      '&.MuiChip-clickable:hover, &.MuiChip-clickable:focus, &.MuiChip-clickable:active': {
        boxShadow: 'none',
      },
      '& .MuiChip-icon': { color: 'var(--app-btn-pill-text)' },
    }
  }
  return {
    color: 'var(--app-text-primary)',
    bgcolor: 'var(--app-bg-panel, #fff)',
    border: '1px solid var(--app-border-subtle)',
    '&:hover': { bgcolor: 'var(--app-bg-panel, #fff)' },
  }
}
